module.exports = __webpack_public_path__ + "img/cat2.3a7557c8.png";